// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/

// XXX stub for react-i18next Trans component
export const Trans = ({children})=>children;
